<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner ></mat-spinner>
</div>
<div class="col-md-12">
    <button class="btnBack" (click)="goBack($event)" type="button">
      <span class="back-arrow">←</span>
      <span class="back-text">Back</span>
    </button>
</div>

<div class="col-md-12 mt-4 flex">
    <div class="col-md-2">
       <!-- Show barcode icon when source is barcode_scan -->
       <div *ngIf="isBarcodeScan()" class="barcode-placeholder edit-barcode">
           <svg class="barcode-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
               <path d="M2 4h2v16H2V4zm4 0h1v16H6V4zm3 0h1v16H9V4zm2 0h2v16h-2V4zm4 0h2v16h-2V4zm4 0h1v16h-1V4zm2 0h2v16h-2V4z"/>
           </svg>
       </div>
       <!-- Show food image otherwise -->
       <a *ngIf="!isBarcodeScan()" href="#" data-toggle="modal" data-target="#imgModal"><img class="imgClass" src="{{foodDetails.foodImageUrl}}"/></a>
       <br/>
       <a *ngIf="!isBarcodeScan()" href="#" data-toggle="modal" data-target="#imgModal" class="imgText">View Image</a>
    </div>
    <div class="col-md-10">
        <div class="col-md-12 form-group mt-3">
            <label for="foodName" class="form-label labels">Food Log Name:</label>
            <input type="text" id="foodName" class="form-control fieldClass" [(ngModel)]="foodDetails.name" [ngModelOptions]="{standalone: true}" placeholder="Enter food log name" />
        </div>

        <div class="col-md-12 mt-3">
            <div class="form-group" style="display: flex; gap: 20px; align-items: flex-end;">
                <div class="date-time-field">
                    <label for="logDate" class="form-label labels">Date:</label>
                    <input type="date" 
                           id="logDate" 
                           name="logDateInput"
                           class="form-control date-time-input" 
                           [ngModel]="logDate"
                           (ngModelChange)="onDateChange($event)"
                           [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="date-time-field">
                    <label for="logTime" class="form-label labels">Time:</label>
                    <input type="time" 
                           id="logTime" 
                           name="logTimeInput"
                           class="form-control date-time-input" 
                           [ngModel]="logTime"
                           (ngModelChange)="onTimeChange($event)"
                           [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
        </div>

       <app-total-nutri [foodInfo]="foodTotalCal"></app-total-nutri>

       <div class="col-md-12 mt-5">
        <form #f="ngForm" (ngSubmit)="updateFoodLog()">
   
            <div class="col-lg-12 form-group float ">
               
                <label for="exampleInputEmail1" class="form-label labels">Notes:</label>
          
                <textarea class="form-control fieldClass" [(ngModel)]="foodDetails.notes"  [ngModelOptions]="{standalone: true}" row="5" matInput>{{foodDetails.notes}}</textarea>
               
         
        </div>
            <!-- <div class="col-lg-6 form-group float mt-3">
               
                    <label for="exampleInputEmail1" class="form-label labels">Number of Servings</label>
              
                    <input matInput (keyup)="changeServingNo($event)" [(ngModel)]="foodDetails.serving.quantity"  [ngModelOptions]="{standalone: true}" type="number" placeholder="Type Here..." class="form-control inputField fieldClass" id="exampleInputEmail1" aria-describedby="emailHelp">
                   
             
            </div> -->

            <div class="col-lg-6 form-group float mt-3">

                <label for="exampleInputEmail1"  class="form-label labels">Meal Type</label>

               <select [(ngModel)]="foodDetails.mealType"  [ngModelOptions]="{standalone: true}" class="form-control fieldClass">
                <option value="Breakfast">Breakfast</option>
                <option value="Lunch">Lunch</option>
                <option value="Snack">Snack</option>
                <option value="Dinner">Dinner</option>
               </select>
        </div>

            <div class="col-lg-6 form-group float mt-3">

                <label for="mealLocation"  class="form-label labels">Meal Location</label>

               <select [(ngModel)]="foodDetails.mealLocation"  [ngModelOptions]="{standalone: true}" class="form-control fieldClass">
                <option value="Home">Home</option>
                <option value="Outside">Outside</option>
               </select>
        </div>


    <!-- <div class="col-lg-6 form-group float mt-3">
               
        <label for="exampleInputEmail1" class="form-label labels">Serving Size</label>
  
        <input matInput type="text" (keyup)="changeServingSize($event)" [(ngModel)]="foodDetails.serving.size"  [ngModelOptions]="{standalone: true}"  placeholder="Type Here..." class="form-control inputField fieldClass" />
    </div> -->
    <!-- <div class="col-lg-6 form-group float mt-3">
                
        <label for="exampleInputEmail1" class="form-label labels">Serving Unit</label>

        <input matInput type="text" [(ngModel)]="foodDetails.serving.unit"  [ngModelOptions]="{standalone: true}"  placeholder="Type Here..." class="form-control inputField fieldClass" id="exampleInputEmail1" aria-describedby="emailHelp">
    
    </div> -->



            </form>
       </div>
    </div>
</div>

<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
    <h2 style="margin: 0;">Overall Ingredients</h2>
    <button type="button" class="btn btn-primary btnClass" (click)="addIngredient()" style="margin: 0;">
        Add Ingredient
    </button>
</div>

<div class="table-wrapper">
<table mat-table [dataSource]="dataSource">

   
    <!-- Name Column -->
    <ng-container matColumnDef="Ingredients">
      <th mat-header-cell *matHeaderCellDef class="ingredients-column-header"> Ingredients </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="ingredients-column-cell">
        <input type="text" class="form-control ingredients-input" [(ngModel)]="element.name" [ngModelOptions]="{standalone: true}" (change)="changeIngredientName($event, i)" />
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="Number of Servings">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Number of Servings </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" min="1" (change)="changeNoServing($event,i,1)"  class="form-control numeric-input" value="{{element.serving.quantity}}" />
      </td>
      <!-- <td mat-cell *matCellDef="let element;let i = index;" ><input type="number" (change)="changeNoServing($event,i,1)"  class="form-control textField" value="{{element.serving.quantity}}" /> </td> -->
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="Serving Unit">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Serving Unit </th>
      <td mat-cell *matCellDef="let element;let i=index" class="numeric-column-cell">
        <!-- Editable dropdown for NEW ingredients -->
        <select *ngIf="element.isNew" class="form-control serving-unit-select" (change)="changeNoServing($event,i,3)" [(ngModel)]="element.serving.unit" [ngModelOptions]="{standalone: true}">
          <option value="grams">Grams</option>
          <option value="ounces">Ounces</option>
          <option value="fluid ounces">Fluid Ounces</option>
          <option value="cups">Cups</option>
        </select>
        <!-- Read-only display for EXISTING ingredients -->
        <div *ngIf="!element.isNew" class="unit-cell" (click)="toggleUnitTooltip($event, i)">
          <span class="unit-value">{{element.serving.unit}}</span>
        </div>
        <div class="unit-tooltip" *ngIf="showUnitTooltip === i && !element.isNew" [style.top]="unitTooltipStyle.top" [style.left]="unitTooltipStyle.left">
          Sorry, only members can change food log units
        </div>
      </td>
    </ng-container>


    <ng-container matColumnDef="Serving Size">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Serving Size </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" (change)="changeNoServing($event,i,2)"  class="form-control numeric-input" value="{{element.serving.size}}" />
      </td>
    </ng-container>

    <ng-container matColumnDef="Calories">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Calories </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <div class="calories-cell" (click)="toggleCaloriesTooltip($event, i)">
          <span class="calories-value">{{element.nutrition.calories | number:'1.0-0'}}</span>
        </div>
        <div class="calories-tooltip" *ngIf="showCaloriesTooltip === i" [style.top]="tooltipStyle.top" [style.left]="tooltipStyle.left">
          Ingredient calories are for reference only. Please edit macros to update calories.
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Proteins">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Proteins </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.protein" [ngModelOptions]="{standalone: true}" (change)="changeNutritionValue($event, i, 'protein')" />
      </td>
    </ng-container>

    <ng-container matColumnDef="Carbs">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Carbs </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.carbs" [ngModelOptions]="{standalone: true}" (change)="changeNutritionValue($event, i, 'carbs')" />
      </td>
    </ng-container>

   

    <ng-container matColumnDef="Fats">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Fats </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.fat" [ngModelOptions]="{standalone: true}" (change)="changeNutritionValue($event, i, 'fat')" />
      </td>
    </ng-container>

    <ng-container matColumnDef="Fiber">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Fiber </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.fiber" [ngModelOptions]="{standalone: true}" (change)="changeNutritionValue($event, i, 'fiber')" />
      </td>
    </ng-container>

    <ng-container matColumnDef="isUpf">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> isUpf </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <select class="form-control serving-unit-select" [(ngModel)]="element.isUpf" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="Caffeine">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Caffeine </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.caffeine" [ngModelOptions]="{standalone: true}" />
      </td>
    </ng-container>

    <ng-container matColumnDef="Alcohol Grams">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> Alcohol Grams </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <div class="alcohol-grams-cell" (click)="toggleAlcoholGramsTooltip($event, i)">
          <span class="alcohol-grams-value">{{element.nutrition.alcoholGrams | number:'1.1-1'}}</span>
        </div>
        <div class="alcohol-grams-tooltip" *ngIf="showAlcoholGramsTooltip === i" [style.top]="alcoholGramsTooltipStyle.top" [style.left]="alcoholGramsTooltipStyle.left">
          Alcohol grams are calculated from ABV. Please edit ABV to update alcohol grams.
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="ABV">
      <th mat-header-cell *matHeaderCellDef class="numeric-column-header"> ABV </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="numeric-column-cell">
        <input type="number" step="0.1" class="form-control numeric-input" [(ngModel)]="element.nutrition.alcoholAbv" [ngModelOptions]="{standalone: true}" (change)="onAbvChange($event, i)" />
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef class="actions-column-header"> Actions </th>
      <td mat-cell *matCellDef="let element;let i = index;" class="actions-column-cell">
        <button type="button" class="btn btn-danger delete-btn" (click)="deleteIngredient(i)" title="Delete Ingredient">
          X
        </button>
      </td>
    </ng-container>

   

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
 

  <div class="col-md-3 floatRight"> <button type="button" class="btn btnClass" [class.btn-disabled]="!hasIngredients()" [disabled]="!hasIngredients()" (click)="updateFoodLog()">Update</button></div>

  <div class="modal fade" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="imgModalLabel" aria-hidden="true">
   <div class="modal-dialog modal-xl " role="document">
     <div class="modal-content modal-size-style">
       <div class="modal-header">
         <h5 class="modal-title">Food Log</h5>
         <button type="button" class="close" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
         </button>
       </div>
       <div class="modal-body">
         <img width="100%" src="{{foodDetails.foodImageUrl}}" />
       </div>
       <div class="modal-footer">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
       </div>
     </div>
   </div>
 </div>
